import { module } from 'angular';
import component from './kndef-krepre-list.component';
import './kndef-krepre-list.scss';

export default module('app')
	.component('kndefKrepreList', component)
	.name;
